// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"aaf83cf2","667":"24f89535","977":"34300a84"}[chunkId] + ".chunk.js";
};